module.exports = __webpack_public_path__ + "img/imgCard01.28bf5700.jpg";